import isEmpty from 'lodash/isEmpty';
import * as constants from '../constants';
import { createReducer } from '../../../utils';

const initialState = {
  file: null,
  croppedImageBlob: null,
  hasRegisteredChanges: false,
  s3ScannedURI: '',
  media: [],
  isNewMedia: true,
  hasMediaUpdates: false,
  hasLogoUpdates: false,
};

export default createReducer(initialState, {
  [constants.SET_LOGO_FILE]: (state, { file }) => ({
    ...state, file, hasRegisteredChanges: true,
  }),
  [constants.SET_LOGO_S3_SCANNED_URI]: (state, { s3ScannedURI }) => ({
    ...state, s3ScannedURI, hasRegisteredChanges: true, hasLogoUpdates: true,
  }),
  [constants.SET_CROPPED_LOGO_FILE]: (state, { croppedImageBlob }) => ({
    ...state, croppedImageBlob, hasRegisteredChanges: true,
  }),
  [constants.INITIALIZE_MEDIA]: (state, { media, hasRegisteredChanges = true, isNewMedia, productId }) => ({
    ...state, media: media.concat(new Array(31 - media.length).fill({})), hasRegisteredChanges, isNewMedia, productId,
  }),
  [constants.DELETE_MEDIA_ITEM]: (state, { itemToDeleteIndex }) => {
    let currentOrder = 0;

    let media = state.media.map((item, index) => {
      currentOrder += 1;
      if (index !== itemToDeleteIndex) {
        return item.order ? { ...item, order: currentOrder } : item;
      }
      currentOrder -= 1;
      return {};
    });
    media = media.filter((a) => a.order);
    media = media.concat(new Array(31 - media.length).fill({}));

    return {
      ...state,
      media,
      hasRegisteredChanges: true,
      hasMediaUpdates: true,
    };
  },
  [constants.SAVE_PHOTO_CAPTION]: (state, { caption, photoIndex }) => (
    {
      ...state,
      media: state.media.map((item, index) => {
        if (index !== photoIndex) {
          return item;
        }
        return {
          ...item,
          caption,
        };
      }),
      hasRegisteredChanges: true,
      hasMediaUpdates: true,
    }
  ),
  [constants.SET_PHOTO_S3_SCANNED_URI]: (state, { mediaDisplayUrl, targetIndex }) => (
    {
      ...state,
      tileSelected: { id: targetIndex },
      media: state.media.map((item, index) => {
        if (index !== targetIndex) {
          return item;
        }
        return {
          ...item,
          title: item.title || 'placeholder',
          order: item.order || (targetIndex + 1),
          caption: item.caption || ' ',
          media_type: 'IMAGE_S3',
          media_url: mediaDisplayUrl,
          mediaDisplayUrl,
        };
      }),
      hasRegisteredChanges: true,
      hasMediaUpdates: true,
    }
  ),
  [constants.SET_CROPPED_PHOTO_FILE]: (state, { croppedImageBlob, targetIndex }) => (
    {
      ...state,
      media: state.media.map((item, index) => {
        if (index !== targetIndex) {
          return item;
        }
        return {
          ...item,
          croppedImageBlob,
        };
      }),
      hasRegisteredChanges: true,
      hasMediaUpdates: true,
    }
  ),
  [constants.SET_VIDEO]: (state, { video, targetIndex }) => ({
    ...state,
    media: state.media.map((item, index) => {
      if (index !== targetIndex) {
        return item;
      }
      delete item.file;
      return {
        ...item,
        media_url: video.mediaDisplayUrl,
        media_type: 'VIDEO_URL',
        mediaDisplayUrl: video.mediaDisplayUrl,
        caption: video.caption,
        order: item.order || (targetIndex + 1),
      };
    }),
    hasRegisteredChanges: true,
    hasMediaUpdates: true,
  }),
  [constants.RESET_MEDIA_CHANGES_FLAG]: (state) => ({
    ...state,
    hasRegisteredChanges: false,
    isNewMedia: state.media.filter((a) => !isEmpty(a)).length === 0,
    s3ScannedURI: '',
    croppedImageBlob: null,
    hasMediaUpdates: false,
  }),
});
